'use client'

import type { ComponentProps } from 'react'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { LIGHT_FIELD_CLASS, LIGHT_HELP_CLASS } from '@/components/santa-video/light-field'
import { OptionalTag } from '@/components/santa-video/optional-tag'
import { cn } from '@/lib/utils'

interface OrderTextFieldProps extends ComponentProps<typeof Input> {
  id: string
  label: string
  help?: string
  /** Si viene, el campo es opcional y la etiqueta lo dice. */
  optionalTag?: string
}

/** Un campo simple del formulario, sobre la superficie clara: `label` + ayuda opcional + `Input`. */
export function OrderTextField({ id, label, help, optionalTag, className, ...inputProps }: OrderTextFieldProps) {
  return (
    <div className="flex flex-col gap-2">
      <Label className="block text-stone-800" htmlFor={id}>{label}<OptionalTag tag={optionalTag} /></Label>
      {help && <p className={LIGHT_HELP_CLASS}>{help}</p>}
      <Input className={cn(LIGHT_FIELD_CLASS, className)} id={id} {...inputProps} />
    </div>
  )
}
